import { useEffect } from 'react';

interface useClickOutsideProps {
  callback: (event: MouseEvent) => void;
  ref: React.RefObject<HTMLElement | null>;
}

export const useClickOutside = ({ callback, ref }: useClickOutsideProps) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callback(event);
      }
    };

    document.addEventListener('mousedown', handleClickOutside, true);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside, true);
    };
  }, [callback, ref]);
};
